// Thin same-origin API client. All calls are /api/*; the session rides the
// httpOnly cookie, so there is no token handling here.

export interface SessionUser {
  id: string;
  email: string;
  verified: boolean;
  theme: string;
  timezone: string;
  timezoneSource: string;
}

export interface ExpertLite {
  id: string;
  kind: string;
  name: string;
  short: string | null;
  expertType: string | null;
  role: string | null;
  lens: string | null;
  status: string;
  cat: string | null;
  cats: string[];
  reach: string | null;
  topicLabels: string[] | null;
  photo: string | null;
  photoPos: string | null;
  photoBy: string | null;
  photoLicense: string | null;
  photoLicenseUrl: string | null;
  photoPage: string | null;
  initials: string | null;
  color: string | null;
  claimed: boolean;
  cardCount: number;
  feedCount: number;
}

async function json<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return (await res.json()) as T;
}

export const api = {
  async session(): Promise<SessionUser | null> {
    const body = await json<{ user: SessionUser | null }>(await fetch("/api/auth/session"));
    return body.user;
  },
  async requestLink(
    email: string,
    inviteCode?: string,
    flow: "signup" | "signin" = "signup",
  ): Promise<{ ok: boolean; error?: string; needsInvite?: boolean }> {
    const res = await fetch("/api/auth/request-link", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(inviteCode ? { email, inviteCode, flow } : { email, flow }),
    });
    return (await res.json()) as { ok: boolean; error?: string; needsInvite?: boolean };
  },
  async signOut(): Promise<void> {
    await fetch("/api/auth/signout", { method: "POST" });
  },
  async experts(): Promise<ExpertLite[]> {
    const body = await json<{ experts: ExpertLite[] }>(await fetch("/api/experts"));
    return body.experts;
  },
};
